import { useNavigate } from 'react-router-dom';
import { RoomWithMembers, RoomWithMembersAndStages } from '../../common/types';
import { UserIcon } from '../user/UserIcon';
import { RoomStageProgress } from '../stages/RoomStageProgress';

export type ListedRoomProps = {
  room: RoomWithMembersAndStages;
  memberColors: { [key: string]: string };
};

export function ListedRoom(props: ListedRoomProps) {
  const navigate = useNavigate();
  const { room } = props;

  const maxMembers = room.size; // The number of circles is based on room size

  return (
    <div className="room-card bg-[#1e2a38] p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-white text-2xl font-bold">Room #{room.number}</h3>
        <button
          className="bg-white text-black py-2 px-4 rounded hover:bg-gray-200 transition-colors duration-300"
          onClick={() => navigate(`/rooms/${room.uuid}`)}
        >
          Join
        </button>
      </div>
      <div>
        <RoomStageProgress stages={room.stages} />
      </div>

      <div className="mb-4">
        <h4 className="text-gray-300 mb-2">Members:</h4>
        <div className="flex flex-wrap gap-2">
          {room.members.map((member) => (
            <UserIcon
              key={member.userUuid}
              user={member}
              color={props.memberColors[member.userUuid]}
            />
          ))}

          {/* Fill the remaining space with empty placeholders if less than max members, but make sure we don't break the layout */}
          {maxMembers - room.members.length > 0 &&
            [...Array(Math.max(maxMembers - room.members.length, 1))].map((_, index) => (
              <div key={`empty-${index}`} className="rounded-full bg-gray-600 w-10 h-10" />
            ))}
        </div>
      </div>
    </div>
  );
}
